import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { jwtDecode } from "jwt-decode"; // ✅ FIXED import
import { login, register, forgotPassword, logoutUser } from "./authApi";

// Simulate an async login
export const loginUser = createAsyncThunk(
  "auth/loginUser",
  async (credentials, thunkAPI) => {
    try {
      const response = await login(credentials);
      const decoded = jwtDecode(response.token); // ✅ now works correctly

      const user = {
        _id: decoded._id,
        email: decoded.email,
        name: decoded.name,
        role: decoded.role || "superadmin", // adjust based on token payload
      };

      return { ...user, token: response.token };
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data || error.message);
    }
  }
);

// Simulate an async logout
export const logout = createAsyncThunk(
  "auth/logoutUser",
  async (credentials, thunkAPI) => {
    try {
      const response = await logoutUser(credentials);
      return "Logout successfully";
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data || error.message);
    }
  }
);

const authSlice = createSlice({
  name: "auth",
  initialState: {
    _id: null,
    email: null,
    role: null,
    token: null,
    name: null,
    loading: false,
    error: null,
  },
  reducers: {
    logout: (state) => {
      state._id = null;
      state.email = null;
      state.name = null;
      state.role = null;
      state.token = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false;
        state.email = action.payload.email;
        state._id = action.payload._id;
        state.name = action.payload.name;
        state.role = action.payload.role;
        state.token = action.payload.token;
        localStorage.setItem("token", action.payload.token);
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export default authSlice.reducer;

// export a simple action to clear auth state (used by HTTP interceptor)
export const { logout: clearAuth } = authSlice.actions;
